import { Model } from '@vuex-orm/core'
import Article from '@models/helpers/Article'

export default class File extends Model {
  static entity = 'files';  
  
  static fields () {
    return {
      id: this.attr(null),
      file_name: this.attr(null),
      language_id: this.attr(null),
      article_id: this.attr(null),
      type_id: this.attr(null),
      
      article: this.belongsTo(Article, 'article_id')
    }
  }
}
  